import { computed, input, output } from '@angular/core';
import { EditPortfolioConfirmationDetailsComponent } from '../agent-tool-permission-box/edit-portfolio-confirmation-details/edit-portfolio-confirmation-details.component';
import { UpdateWatchlistConfirmationDetailsComponent } from '../agent-tool-permission-box/update-watchlist-confirmation-details/update-watchlist-confirmation-details.component';
import * as i0 from "@angular/core";
function AgentToolEditConfirmationBoxComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-update-watchlist-confirmation-details", 1);
} if (rf & 2) {
    i0.ɵɵproperty("details", ctx);
} }
function AgentToolEditConfirmationBoxComponent_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-edit-portfolio-confirmation-details", 1);
} if (rf & 2) {
    i0.ɵɵproperty("details", ctx);
} }
export class AgentToolEditConfirmationBoxComponent {
    constructor() {
        this.toolCall = input.required(...(ngDevMode ? [{ debugName: "toolCall" }] : []));
        this.confirm = output();
        this.displayName = computed(() => this.toolCall().display_name || this.toolCall().name, ...(ngDevMode ? [{ debugName: "displayName" }] : []));
        this.hasError = computed(() => !!this.toolCall().details.error, ...(ngDevMode ? [{ debugName: "hasError" }] : []));
        this.updateWatchlistDetails = computed(() => {
            const { details } = this.toolCall();
            return details.kind === 'update_watchlist' ? details : null;
        }, ...(ngDevMode ? [{ debugName: "updateWatchlistDetails" }] : []));
        this.editPortfolioDetails = computed(() => {
            const { details } = this.toolCall();
            return details.kind === 'edit_portfolio' ? details : null;
        }, ...(ngDevMode ? [{ debugName: "editPortfolioDetails" }] : []));
    }
    authorize() {
        this.confirm.emit({ authorize: true });
    }
    reject() {
        this.confirm.emit({ authorize: false });
    }
}
AgentToolEditConfirmationBoxComponent.ɵfac = function AgentToolEditConfirmationBoxComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentToolEditConfirmationBoxComponent)(); };
AgentToolEditConfirmationBoxComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentToolEditConfirmationBoxComponent, selectors: [["ycn-agent-tool-edit-confirmation-box"]], inputs: { toolCall: [1, "toolCall"] }, outputs: { confirm: "confirm" }, decls: 12, vars: 4, consts: [[1, "pt-3", "pr-20", "pb-3", "pl-20", "bg-white", "rounded-4", "mt-20"], [3, "details"], [1, "text-large", "leading-relaxed"], [1, "row", "mt-3", "mb-10"], [1, "col-6"], [1, "btn", "btn-secondary", "btn-block", 3, "click"], [1, "btn", "btn-primary", "btn-block", 3, "click", "disabled"]], template: function AgentToolEditConfirmationBoxComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵconditionalCreate(1, AgentToolEditConfirmationBoxComponent_Conditional_1_Template, 1, 1, "ycn-update-watchlist-confirmation-details", 1);
        i0.ɵɵconditionalCreate(2, AgentToolEditConfirmationBoxComponent_Conditional_2_Template, 1, 1, "ycn-edit-portfolio-confirmation-details", 1);
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 3)(6, "div", 4)(7, "button", 5);
        i0.ɵɵlistener("click", function AgentToolEditConfirmationBoxComponent_Template_button_click_7_listener() { return ctx.reject(); });
        i0.ɵɵtext(8, "Reject");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(9, "div", 4)(10, "button", 6);
        i0.ɵɵlistener("click", function AgentToolEditConfirmationBoxComponent_Template_button_click_10_listener() { return ctx.authorize(); });
        i0.ɵɵtext(11, "Allow");
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        let tmp_0_0;
        let tmp_1_0;
        i0.ɵɵadvance();
        i0.ɵɵconditional((tmp_0_0 = ctx.updateWatchlistDetails()) ? 1 : -1, tmp_0_0);
        i0.ɵɵadvance();
        i0.ɵɵconditional((tmp_1_0 = ctx.editPortfolioDetails()) ? 2 : -1, tmp_1_0);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1("Please confirm the proposed changes for ", ctx.displayName(), ". ");
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("disabled", ctx.hasError());
    } }, dependencies: [EditPortfolioConfirmationDetailsComponent, UpdateWatchlistConfirmationDetailsComponent], encapsulation: 2, changeDetection: 0 });
